<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

    <app-list-view [title]="t('common.labels.reporttemplates')" [messages]="messages" [loading]="loading">

      <div buttons>
        <button withRight="admin.reporttemplate.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
        <button [withRight]="'admin.reporttemplate.upload'" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-success p-ml-2 p-mb-2 autofocus"></button>
      </div>

      <div table>
        <p-table
          [value]="reporttemplates"
          [paginator]="true"
          [rows]="20"
          stateStorage="local"
          stateKey="reporttemplates-list"
          [rowsPerPageOptions]="rowsPerPage"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="t('common.labels.current_page_report')"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 50%">{{ t('common.labels.file') }}</th>
                    <th style="width: 150px;"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-reporttemplate>
                <tr *ngIf="inEdit !== true || editReporttemplate !== reporttemplate">
                  <td><p>{{ reporttemplate.public_name }}</p></td>
                  <td style="vertical-align: top; text-align: right">
                    <span *ngIf="inEdit !== true">
                      <button [withRight]="'admin.reporttemplate.download'"pButton (click)="onDownload(reporttemplate)" type="button" icon="pi pi-download" class="p-ml-2"></button>
                      <button [withRight]="'admin.reporttemplate.test'" pButton (click)="onOpenTestWindow(reporttemplate)" type="button" icon="pi pi-play-circle" class="p-button-outlined p-ml-2"></button>
                      <button [withRight]="'admin.reporttemplate.delete'" *ngIf="reporttemplate.deletable" pButton (click)="onStartDelete(reporttemplate)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2"></button>
                    </span>
                  </td>
                </tr>
                <tr *ngIf="inEdit === true && editReporttemplate === reporttemplate">
                  <ng-template [ngTemplateOutlet]="tForm"></ng-template>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="no-data" colspan="4">{{ t('common.texts.no_files') }}</td>
              </tr>
            </ng-template>
        </p-table>
      </div>

    </app-list-view>

  </form>

  <ng-template #tForm>
    <td colspan="3" style="vertical-align: top;">
      <app-form-control [cid]="'filename'" [control]="form.get('filename')" [type]="'input'" [label]="''" [basevalue]="editReporttemplate?.public_name"></app-form-control>
    </td>
    <td style="vertical-align: top; text-align: right">
      <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
    </td>
  </ng-template>

  <app-file-handling
    #filehandler
    [mode]="'reporttemplates'"
    [type]="'aireport.template'"
    [accept]="'.ppt,.pptx'"
    (filesUpload)="onFilesUpload($event)"
    (fileDelete)="onDelete($event)"
  ></app-file-handling>

  <p-dialog [header]="t('reporttemplates.test_template') + ': ' + testResource?.public_name" [(visible)]="testVisible" [modal]="true" [style]="{width: '70vw', 'max-width': '680px'}">
    <textarea
      rows="10"
      pInputTextarea
      [(ngModel)]="testJson"
      style="width: 100%;"
    ></textarea>
    <ng-template pTemplate="footer">
      <div class="p-text-right">
        <button pButton (click)="onRunTest()" type="button" aria-label="{{ t('reporttemplates.start_test') }}" [label]="t('reporttemplates.start_test')" [disabled]="testBusy === true"></button>
      </div>
    </ng-template>
  </p-dialog>

</ng-container>
